__turbopack_context__.v({
  "animationBaseSlide": "animation-module__OUwkBG__animationBaseSlide",
  "animationBaseZoom": "animation-module__OUwkBG__animationBaseZoom",
  "animationContainer": "animation-module__OUwkBG__animationContainer",
  "animationContainerWT": "animation-module__OUwkBG__animationContainerWT",
  "animationFrameContent": "animation-module__OUwkBG__animationFrameContent",
  "animationFrameContentLeft": "animation-module__OUwkBG__animationFrameContentLeft",
  "animationFrameContentRight": "animation-module__OUwkBG__animationFrameContentRight",
  "animationFrameContentWithTransition": "animation-module__OUwkBG__animationFrameContentWithTransition",
  "animationSlideFade": "animation-module__OUwkBG__animationSlideFade",
  "animationZoomFade": "animation-module__OUwkBG__animationZoomFade",
});
